import { useEffect, useState } from "react";
import { Feature, FeatureCollection } from "geojson";

export function useFilteredAlerts(
    rawAlerts: FeatureCollection,
    selectedTime: number
): FeatureCollection
{
    const [ filteredAlerts, setFilteredAlerts ] = useState<FeatureCollection>( {
        type: "FeatureCollection",
        features: [],
    } );

    useEffect( () =>
    {
        const filtered = rawAlerts.features.filter( ( feature: Feature ) =>
        {
            const endsStr = feature?.properties?.ends;

            if ( endsStr === undefined ) return true;
            if ( endsStr === null ) return true;

            const endsTime = new Date( endsStr ).getTime();

            return selectedTime <= endsTime;
        } );

        setFilteredAlerts( {
            type: "FeatureCollection",
            features: filtered,
        } );
    }, [ selectedTime, rawAlerts ] );

    return filteredAlerts;
}
